import React, { useState } from 'react'
import './frontpage.css'
import Phone from '../../components/phone/Phone.jsx'
const Frontpage = () => {
  return (
    <>
<div className="frontpageDivsWrapper" id='FrontPage'>
<Phone/> 
</div>

    </>
  )
}

export default Frontpage